import {
  AppBar,
  Avatar,
  Box,
  Container,
  Divider,
  IconButton,
  ImageListItem,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  Badge,
  styled,
} from "@mui/material";
import React, { ReactNode } from "react";
import variables from "../../../assets/styles/variables.module.scss";
import LogoImage from "../../../assets/images/ZeaIQ-Logo.svg";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ProImg from "../../../assets/images/defaultProfileImage.jpg";
import { SetLogout } from "../../Store/AuthReducer/AuthActions";
import { useDispatch } from "react-redux";

interface MyComponentProps {
  children?: ReactNode; // Ensure you define children prop type
}
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const AdminLayout: React.FC<MyComponentProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };


  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
    // navigate("/logout")
  };

  const handleLogout = () => {
  setAnchorElUser(null);
  navigate("/logout"); 
};

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
 
  const navItems = [
    // { name: "Dashboard", path: "/admin" },
    { name: "Organizations", path: "/admin/organization" },
    { name: "Users", path: "/admin" },
    { name: "Teams", path: "/admin/teams" },
    // { name: "Roles", path: "/roles" },
    // { name: "Models", path: "/models" },
    // { name: "Audit Log", path: "/audit-log" },
    // { name: "Subscription", path: "/subscription" },
  ];
  return (
    <>
      <Container
        maxWidth={false}
        sx={{
          borderBottom: `1px solid ${variables.borderColor}`,
          position: "sticky",
          top: "0",
          zIndex: "6",
        }}
      >
        <AppBar
          component="nav"
          position="static"
          elevation={0}
          sx={{ px: { lg: 1 } }}
        >
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 2,
            }}
          >
            <ImageListItem
              sx={{
                marginRight: { xs: "auto", sm: "auto", md: "unset" },
                "&:hover": {
                  cursor: "pointer",
                  transform: "scale(1.05)",
                  transition: "transform 0.3s ease-in-out",
                },
              }}
            // onClick={() => navigate("/home")}
            >
              <img
                src={LogoImage}
                alt="Company Logo"
                style={{ width: 150, height: "auto" }}
              />
            </ImageListItem>

            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Box
                sx={{
                  display: "flex",
                }}
              >
                {navItems.map((item, index) => (
                  <ListItem key={index} disablePadding>
                    <ListItemButton
                      sx={{
                        textAlign: "center",
                        "&:hover": {
                          backgroundColor: "transparent", // Remove hover background color
                        },
                      }}
                    >
                      <ListItemText
                        primary={item.name}
                        onClick={() => navigate(item.path)}
                        sx={{ whiteSpace: "nowrap" }}
                        primaryTypographyProps={{
                          fontSize: "14px", // Set font size here
                          fontWeight: "500", // Optional: Adjust font weight
                          color:
                            location.pathname === item.path
                              ? variables.primaryColor
                              : "text.primary",
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Box sx={{ flexGrow: 0 }}>
                {/* Avatar Button */}
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    variant="dot"
                  >
                    <Avatar src={ProImg} />
                  </StyledBadge>
                </IconButton>
                {/* Dropdown Menu */}
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                  PaperProps={{ sx: { minWidth: "180px" } }}
                >
                  {/* Admin Info */}
                  <Box sx={{ display: "flex", flexDirection: "column", px: 2 }}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        color: variables.textColor,
                      }}
                    >
                      Admin
                    </Typography>
                    <Typography variant="caption" fontWeight="400" gutterBottom>
                      Zealogics
                    </Typography>
                  </Box>

                  <Divider sx={{ my: 1 }} />

                  {/* Log Out Option */}
                  <MenuItem onClick={handleLogout}>
                    <Typography variant="body2">Log Out</Typography>
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      </Container>
      {/* {props.children} */}
      <Box
        sx={{
          minHeight: "calc(100vh - 78px)",
        }}
      >
        <Outlet /> {/* This will render nested routes */}
      </Box>
    </>
  );
};

export default AdminLayout;
